import CoinSparkles from "@/assets/images/3d-icons/coin-sparkles.png";
import { Link } from "@/components/shared/link";
import { Typography } from "@/components/shared/typography";
import { Card, Image, View } from "@/components/ui";

type ServiceCreditTopUpType = "massage" | "beauty" | "pet";

const serviceCreditTopUpConfig: Record<
  ServiceCreditTopUpType,
  {
    title: string;
    href: string;
  }
> = {
  massage: {
    title: "Pay Your Massage with Credits",
    href: "/profile/credit-account/massage",
  },
  beauty: {
    title: "Pay Your Home Beauty with Credits",
    href: "/profile/credit-account/beauty",
  },
  pet: {
    title: "Pay Your Pet Care with Credits",
    href: "/profile/credit-account/pet",
  },
};

export const ServiceCreditTopUpCard = ({
  service,
}: {
  service: ServiceCreditTopUpType;
}) => {
  const { title, href } = serviceCreditTopUpConfig[service];

  return (
    <Card className="flex flex-row gap-3 p-3">
      <View className="h-6 w-6 md:h-7 md:w-7">
        <Image src={CoinSparkles} alt="Coin Sparkles" />
      </View>
      <View className="flex flex-1 flex-col gap-0.5">
        <Typography variant="label-sm">{title}</Typography>
        <Typography variant="caption-md">
          Get additional bonus depending on the amount of credit you purchase.{" "}
          <Link href={href} className="text-brand-primary">
            Click here to top up
          </Link>
        </Typography>
      </View>
    </Card>
  );
};
